(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["service-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountCareFinder = (root) => {
      if (!root || root.dataset.careFinderReady === 'true') return;
      root.dataset.careFinderReady = 'true';

      const buttons = [...root.querySelectorAll('[data-care]')];
      const result = root.querySelector('.care-finder__result');
      const concern = root.querySelector('[data-care-concern]');
      const title = root.querySelector('[data-care-title]');
      const copy = root.querySelector('[data-care-copy]');
      const count = root.querySelector('[data-care-count]');
      const meta = root.querySelector('[data-care-meta]');
      const tags = root.querySelector('[data-care-tags]');
      const learn = root.querySelector('[data-care-learn]');
      const book = root.querySelector('[data-care-book]');

      const renderPills = (container, value) => {
        container.replaceChildren(...value.split('|').filter(Boolean).map((text) => {
          const pill = document.createElement('span');
          pill.textContent = text;
          return pill;
        }));
      };

      const selectCare = (button, updateHash = true) => {
        if (!button) return;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        concern.textContent = button.dataset.concern;
        title.textContent = button.dataset.title;
        copy.textContent = button.dataset.copy;
        count.textContent = `${button.dataset.number} / 12`;
        renderPills(meta, button.dataset.meta);
        renderPills(tags, button.dataset.tags);
        learn.href = button.dataset.learn;
        book.href = button.dataset.book;
        result.classList.remove('is-updating');
        void result.offsetWidth;
        result.classList.add('is-updating');
        if (updateHash && window.history?.replaceState) window.history.replaceState(null, '', `#care-${button.dataset.care}`);
      };

      buttons.forEach((button) => button.addEventListener('click', () => selectCare(button)));
      const initialKey = window.location.hash.replace('#care-', '');
      const initialButton = buttons.find((button) => button.dataset.care === initialKey);
      if (initialButton) selectCare(initialButton, false);
    };

    document.querySelectorAll('[data-care-finder]').forEach(mountCareFinder);
    document.addEventListener('shopify:section:load', (event) => mountCareFinder(event.target.querySelector('[data-care-finder]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
